import { EventTypes, EntityTypes } from 'typings/enums';

interface ITeamNotifyManagersEventData {
    cycleId: number;
    updatedByUserId: string;
}

export interface ITeamNotifyManagersEvent {
    eventType: EventTypes;
    entityType: EntityTypes;
    data: ITeamNotifyManagersEventData;
}

export const getTeamNotifyManagersEvent = (
    cycleId: number,
    updatedByUserId: string): ITeamNotifyManagersEvent => {
    return {
        eventType: EventTypes.TeamNotifyManagersEvent,
        entityType: EntityTypes.TeamCycle,
        data: {
            cycleId,
            updatedByUserId
        }
    };
};